import React from "react";
import PropTypes from 'prop-types';
import Dialog from './elements/Dialog';
import PurpleButton from "./elements/form/button/PurpleButton";
import CancelButton from "./elements/form/button/CancelButton";

export default class VerificationInfoModal extends React.PureComponent {
    resendVerificationEmailHandler = () => {
        let { resendEmailVerification, email } = this.props;

        return resendEmailVerification(email);
    };
    notificationClosed = () => {
        let { resetEmailVerification } = this.props;

        return resetEmailVerification();
    };
    closeHandler = () => {
        const { hideVerificationModal } = this.props;

        hideVerificationModal();
    };

    render() {
        const {
            isLogged,
            isVerified,
            isResendVerificationPending,
            isPageLoading,
            isVerificationModal,
        } = this.props;

        if (!isLogged || isVerified || isPageLoading || !isVerificationModal) {
            return false;
        }

        return (
            <Dialog isVisible={true} onClose={this.closeHandler} className={'verification-info-modal'}>
                <div className={'text'}>
                    Please note that by resending the email, any previously sent verification links become invalid.<br/>
                    Email delivery will usually happen in a few minutes, but can take up to 1 hour in some cases.<br/>
                    Please always make sure to use the verification link of the latest email.
                </div>
                <div className={'control'}>
                    <div className={'submit-button-container'}>
                        <PurpleButton isLoading={isResendVerificationPending} onClick={this.resendVerificationEmailHandler}>Resend mail</PurpleButton>
                    </div>
                    <CancelButton onClick={this.closeHandler}>Cancel</CancelButton>
                </div>
            </Dialog>
        )
    }
}

VerificationInfoModal.propTypes = {
    isLogged: PropTypes.bool.isRequired,
    isVerified: PropTypes.bool,
    isResendVerificationPending: PropTypes.bool.isRequired,
    isResendVerificationeError: PropTypes.bool.isRequired,
    isResendVerificationSuccess: PropTypes.bool.isRequired,
    isPageLoading: PropTypes.bool.isRequired,
    isVerificationModal: PropTypes.bool.isRequired,
    type: PropTypes.string,
    resetEmailVerification: PropTypes.func.isRequired,
    resendEmailVerification: PropTypes.func.isRequired,
    hideVerificationModal: PropTypes.func.isRequired,
};
